import React, { useState, useEffect } from 'react'
import { useNavigate, Link } from 'react-router-dom'
import './Login.css'

const Login = () => {
  const [formData, setFormData] = useState({
    email: '',
    password: ''
  })
  const [showPassword, setShowPassword] = useState(false)
  const [validationError, setValidationError] = useState('')
  const [isLoading, setIsLoading] = useState(false)

  const navigate = useNavigate()

  // Redirect to dashboard if already authenticated
  useEffect(() => {
    const isAuthenticated = localStorage.getItem('adminAuthToken')
    if (isAuthenticated) {
      navigate('/dashboard')
    }
  }, [navigate])

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    })
    if (validationError) {
      setValidationError('')
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()
    e.stopPropagation()
    setValidationError('')
    setIsLoading(true)

    if (!formData.email || !formData.password) {
      setValidationError('Please fill in all fields')
      setIsLoading(false)
      return
    }

    // TODO: Add actual authentication logic here
    // For now, just redirect to dashboard
    try {
      // Simulate API call
      await new Promise(resolve => setTimeout(resolve, 1000))
      
      // Store auth token/session (placeholder)
      localStorage.setItem('adminAuthToken', 'authenticated')
      
      navigate('/dashboard')
    } catch (err) {
      setValidationError('Login failed. Please try again.')
      console.error('Login error:', err)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className="login-container">
      <form className="login-form" onSubmit={handleSubmit}>
        <h1 className="login-title">Sign in</h1>
        
        {validationError && (
          <div className="login-error">
            <span>{validationError}</span>
            <button 
              type="button"
              onClick={() => setValidationError('')}
              className="clear-error-button"
            >
              ×
            </button>
          </div>
        )}

        <div className="login-field-group">
          <label className="login-label">Email Address</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="email address"
            className="login-input"
          />
        </div>

        <div className="login-field-group">
          <label className="login-label">Password</label>
          <div className="login-input-container">
            <input 
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="password"
              className="login-input"
            />
            <span 
              className="login-eye-icon"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? '👁️' : '👁️‍🗨️'}
            </span>
          </div>
        </div>

        <button
          type="submit"
          disabled={isLoading}
          className="login-button"
        >
          {isLoading ? 'Signing in...' : 'Sign in'}
        </button>

        <div className="login-link-container">
          <p className="login-link-text">
            Don't have an account?{' '}
            <Link to="/signup" className="login-link">
              Sign up
            </Link>
          </p>
        </div>
      </form>
    </div>
  )
}

export default Login










